/* eslint-disable */

import React, { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import CartItem from '../components/CartItem/CartItem'
import CartForm from '../components/Cart/CartForm'
import Product from '../components/Product/Product'
import { MainContext } from '../contexts/MainContext'
import useCart from '../hooks/useCart.js'
import { YMaps } from '@pbe/react-yandex-maps'
import LoginForm from '../components/Authorization/LoginForm'
import { createScope, map, transformProxies } from './helpers'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

let Controller

const CartView = props => {
  const navigate = useNavigate()

  const mainContext = useContext(MainContext)

  const { setCart } = useCart()

  const handleClear = () => {
    setCart([])
  }

  const [ cartTotal, setCartTotal ] = useState(0)
  const [ regularDiscount, setRegularDiscount ] = useState(0)
  const [ couponDiscount, setCouponDiscount ] = useState(0)
  const [ certificateDiscount, setCertificateDiscount ] = useState(0)
  const [ bonusesDiscount, setBonusesDiscount ] = useState(0)
  const [ deliveryCost, setDeliveryCost ] = useState(0)
  const [ deliveryTime, setDeliveryTime ] = useState('')

  const [ orderSuccessful, setOrderSuccessful ] = useState(false)

  const [ suggestedProducts, setSuggestedProducts ] = useState([])
  useEffect(() => {
    let randomProducts = mainContext.catalogItems.find(elem => elem.categoryId == 17)?.items?.sort((a, b) => 0.5 - Math.random())?.slice(0, 10)
    if (randomProducts) {
      setSuggestedProducts(randomProducts)
    }

    document.title = 'Корзина'
    document.querySelector('meta[name="description"]').setAttribute("content", 'Корзина')
  }, [])

  useEffect(() => {
    setCartTotal(mainContext.cartItems.reduce((accumulator, elem) => accumulator + parseInt(elem.cartPrice * elem.cartQty), 0))
    setRegularDiscount(mainContext.cartItems.reduce((accumulator, elem) => accumulator + elem.cartPriceOld != null ? parseInt((elem.cartPriceOld - elem.cartPrice) * elem.cartQty) : 0, 0))
  }, [mainContext.cartItems])
  
  return (
      <>

            {/* <div style={{display: 'none'}} className="af-class-cart-popup-wrapper af-class-an-pickup-points-on-the-map">
              <div className="af-class-cart-popup-form w-form">
                <a href="#" className="af-class-cart-popup-close-button w-inline-block"><img src="images/icon--close-popup.svg" loading="lazy" alt="" className="af-class-cart-popup-close-button-icon" /></a>
                <form action="#" id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" className="af-class-cart-popup af-class-pickup-points">
                  <div className="af-class-cart-popup__title">Пункты самовывоза</div>
                  <div className="af-class-cart-popup__map af-class-pickup-points-on-the-map">
                    <div className="af-class-map__location-wrapper">
                      <div className="w-layout-grid af-class-map__location-discription">
                        <div className="af-class-map__location-title">Кинотеатр «Звезда»</div>
                        <div className="w-layout-grid af-class-map__location-info">
                          <div className="af-class-map__location-adress">Ул. Земляной вал, 18-22, стр 1</div>
                          <div className="af-class-map__location-work-time">Пн-Вс 9.00-21.00</div>
                        </div>
                        <a href="#" className="af-class-button--secondry w-inline-block">
                          <div className="af-class-cart__button--secondry__text">Выбрать пункт самовывоза</div>
                          <div className="af-class-cart__button--secondry__underline" />
                        </a>
                      </div>
                      <div className="af-class-map__location-icon" />
                    </div>
                  </div>
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
              <div className="af-class-cart-popup__close-area" />
            </div> */}

            {/* <div style={{display: 'none'}} className="af-class-cart-popup-wrapper af-class-an-gift-cover">
              <div className="af-class-cart-popup-form w-form">
                <a href="#" className="af-class-cart-popup-close-button w-inline-block"><img src="images/icon--close-popup.svg" loading="lazy" alt="" className="af-class-cart-popup-close-button-icon" /></a>
                <form action="#" id="email-form-2" name="email-form-2" data-name="Email Form 2" method="get" className="af-class-cart-popup af-class-gift-cover">
                  <div className="af-class-cart-popup__title">Подарочная упаковка</div>
                  <div className="w-layout-grid af-class-cart-popup__content--gift-cover">
                    <div className="af-class-cart-popup__image-wrapper"><img src="images/gift-cover.jpg" loading="lazy" alt="" className="af-class-cart-popup__image" /></div>
                    <div className="w-layout-grid af-class-cart-popup__text-wrapper">
                      <div className="af-class-cart-popup__subtitle--gift-cover">Чтобы ваш подарок удобно расположился в праздничном боксе, мы придумали три варианта для его наполнения:</div>
                      <div className="w-layout-grid af-class-cart-popup__discription-cover">
                        <div className="af-class-cart-popup__discription--gift-cover">1. От 2 до 4 пачек кофе (250 гр)</div>
                        <div className="af-class-cart-popup__discription--gift-cover">2. 2 пачки любого чая</div>
                        <div className="af-class-cart-popup__discription--gift-cover">3. 1 пачка чая, 2 пачки кофе (250 гр)</div>
                      </div>
                    </div>
                    <a href="#" className="af-class-button--primary af-class-gift-cover w-button"><span className="af-class-button--primary__gift-cover-text">Добавить за </span> 300 ₽</a>
                  </div>
                </form>
                <div className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
              <div className="af-class-cart-popup__close-area" />
            </div> */}

            <div className="af-class-section af-class-p-cart af-class-wf-section">
              <div className="af-class-container w-container">
                <div style={{border: '1px #777 solid', padding: '10px', borderRadius: '10px', marginBottom: '30px'}}>Новая система лояльности</div>

                <h1 className="af-class-page-title af-class-p-cart">Оформление заказа</h1>

                {orderSuccessful === true ? <div style={{ border: '1px #777 solid', borderRadius: '10px', padding: '10px', width: '100%', marginBottom: '30px' }}>Заказ успешно оформлен!</div> : <></>}

                <div className="w-layout-grid af-class-cart-content" style={{marginBottom: '30px'}}>
                  
                  { mainContext.cartItems.length > 0 && <>
                    {/* <div className="af-class-cart__form w-form">
                        <div className="w-layout-grid af-class-cart__user-info">
                            <h3 className="af-class-cart__user-title">Вход</h3>
                            <LoginForm />
                        </div>
                    </div> */}
                    
                    <YMaps><CartForm cartTotal={cartTotal} couponDiscount={couponDiscount} setCouponDiscount={setCouponDiscount} certificateDiscount={certificateDiscount} setCertificateDiscount={setCertificateDiscount} bonusesDiscount={bonusesDiscount} setBonusesDiscount={setBonusesDiscount} setOrderSuccessful={setOrderSuccessful} setDeliveryCost={setDeliveryCost} setDeliveryTime={setDeliveryTime} /></YMaps>
                  </> }

                  <div className="af-class-cart__summary" id="w-node-bbc00f56-5019-5b0b-692a-bc1f9fb4b506-4e3d362f">
                    <div className="af-class-cart__summary-header">
                      <h2 className="af-class-cart__summary-title">Корзина</h2>
                      { mainContext.cartItems.length > 0 && <a onClick={handleClear} className="af-class-button--secondry w-inline-block">
                        <div className="af-class-cart__button--secondry__text">Очистить корзину</div>
                        <div className="af-class-cart__button--secondry__underline" />
                      </a> }
                    </div>
                    <div className="af-class-cart__summary-body w-form">
                      <div className="af-class-cart__summary-list">
                        { mainContext.cartItems.map((props, index) => <CartItem key={props.id} {...props} />) }
                      </div>
                    </div>
                    
                    { mainContext.cartItems.length > 0 ? <div className="af-class-cart__summary-footer">
                      {/* { mainContext.cartItems.length > 0 &&<a href="#" className="af-class-cart__gift-wrap w-inline-block">
                        <div className="af-class-cart__gift-text">Добавить подарочную упаковку</div>
                        <div className="af-class-question_icon af-class-cart" />
                      </a> } */}
                      <div className="af-class-cart__price-wrapper" style={{gridTemplateColumns: '1fr 1fr'}}>
                        
                        {/* { regularDiscount > 0 && <>
                        <div className="af-class-cart__discount-text">Скидка</div>
                        <div className="w-layout-grid af-class-cart__discount-value-wrapper">
                          <div className="af-class-cart__discount-value">
                            { regularDiscount }
                          </div>
                          <div className="af-class-cart__discount-value-sign">₽</div>
                        </div>
                        </> } */}

                        { couponDiscount > 0 && <>
                        <div className="af-class-cart__discount-text">Скидка по промокоду</div>
                        <div className="w-layout-grid af-class-cart__discount-value-wrapper">
                          <div className="af-class-cart__discount-value">
                            { parseInt(couponDiscount) }
                          </div>
                          <div className="af-class-cart__discount-value-sign">₽</div>
                        </div>
                        </> }

                        { certificateDiscount > 0 && <>
                        <div className="af-class-cart__discount-text">Скидка по сертификату</div>
                        <div className="w-layout-grid af-class-cart__discount-value-wrapper">
                          <div className="af-class-cart__discount-value">
                            { parseInt(certificateDiscount) }
                          </div>
                          <div className="af-class-cart__discount-value-sign">₽</div>
                        </div>
                        </> }

                        { bonusesDiscount > 0 && <>
                        <div className="af-class-cart__discount-text">Скидка по бонусам</div>
                        <div className="w-layout-grid af-class-cart__discount-value-wrapper">
                          <div className="af-class-cart__discount-value">
                            { parseInt(bonusesDiscount) }
                          </div>
                          <div className="af-class-cart__discount-value-sign">₽</div>
                        </div>
                        </> }

                        <div className="af-class-cart__discount-text">Стоимость доставки</div>
                          <div className="w-layout-grid af-class-cart__discount-value-wrapper">
                          <div className="af-class-cart__discount-value">
                            { deliveryCost }
                          </div>
                          <div className="af-class-cart__discount-value-sign">₽</div>
                        </div>

                        {/* { deliveryTime != '' && <><div className="af-class-cart__discount-text">Срок доставки</div>
                          <div className="af-class-cart__discount-value-wrapper" style={{minWidth: 0}}>
                          <div className="af-class-cart__discount-value">
                            { deliveryTime }
                          </div>
                        </div></> } */}

                        <div className="af-class-cart__summ-text">Общая сумма</div>
                        <div className="w-layout-grid af-class-cart__summ-value-wrapper">
                          <div className="af-class-cart__summ-value">
                            { (cartTotal + deliveryCost - couponDiscount - certificateDiscount - bonusesDiscount) > 0 ? cartTotal + deliveryCost - couponDiscount - certificateDiscount - bonusesDiscount : 0 }
                          </div>
                          <div className="af-class-cart__summ-value">₽</div>
                        </div>
                      </div>
                    </div> : <div>Корзина пуста</div> }

                  </div>
                </div>
              </div>
            </div>

            { suggestedProducts.length > 0 && <div className="af-class-section af-class-background-white af-class-p-cart af-class-wf-section">
              <div className="af-class-container w-container">
                <div className="af-class-slider-wrapper af-class-recommend">
                  <div className="cart-recommended-header">Рекомендуем</div>
                  <div style={{gridColumn: '1 / -1'}}>
                    <Splide className="af-class-splide af-class-splide__country-page" options={{ perPage: 3, perMove: 1, gap: '15px', breakpoints: { 991: { perPage: 1 } } }}>
                        { suggestedProducts.map((elem, index) => <SplideSlide className="af-class-splide__slide" key={elem.id}><Product key={elem.id} {...elem} style={{width: '100%'}} styleContainer={{width: '100%', height: '100%', backgroundColor: '#f3f3f3'}} /></SplideSlide> )}
                    </Splide>
                  </div>
                </div>
              </div>
            </div> }

          </>
  )
}

export default CartView

/* eslint-enable */